const genPlaceHolderProducts = (length: number = 18) => Array(length).fill(0);

export default genPlaceHolderProducts;
